import React from 'react';
import Aexpress from '../components/Aexpress';
import Deposits from '../components/Deposits';
import Guarantees from '../components/Guarantees';
import Credits from '../views/credits.c';
import CreditLine from '../components/CreditLine';
import Business from '../components/BusinessList';
import DepositCredit from '../components/DepositCredit';
import Acquiring from '../views/acquiring.c';
import SalaryProject from '../components/SalaryProject';
import VedContract from '../components/Zed';
import PbpEntity from '../views/pbpEntityNew';
import UOaccounts from '../components/UOaccounts';
import Collection from '../components/Collection'
import AcceptingPayments from '../components/AcceptingPayments';
import FOPaccounts from '../components/FOPaccounts';
import CreditLimit from '../components/CreditLimit';
import GovList from '../components/GovList';
import GovProgramms from "../components/GovProgramms";
import ECA from "../components/GovProgramms/components/ECA";
import EnergyList from "../components/EnergyList";
import FinMon from "../components/FinMon";
import CashProceeds from '../components/CashProceeds';
import LoansCorporateClients from '../components/LoansCorporateClients';
import QuickCashBusiness from '../components/QuickCashBusiness';
import ABusiness from '../components/ABusiness';

export default function template() {
    let Component = null,
        {match = {}} = this.props;

    if (match.params && match.params.type) {
        switch (match.params.type) {
            case 'deposits':
                Component = Deposits;
                break;
            case 'creditline':
                Component = CreditLine;
                break;
            case 'guarantees':
                Component = Guarantees;
                break;
            case 'credits':
                location.href = '/business/rko';
                break;
            case 'rko':
                Component = Credits;
                break;
            case 'a-express':
                Component = Aexpress;
                break;
            case 'deposit-credit':
                Component = DepositCredit;
                break;
            case 'acquiring':
                Component = Acquiring;
                break;
            case 'salary-project':
                Component = SalaryProject;
                break;
            case 'ved-contract':
                Component = VedContract;
                break;
            case 'pbp-entity':
                Component = PbpEntity;
                break;
            case 'yuo':
                Component = UOaccounts;
                break;
            case 'accepting-payments':
                Component = AcceptingPayments;
                break;
            case 'collection':
                Component = Collection;
                break;
            case 'fop':
                Component = FOPaccounts;
                break;
            case 'limit':
                Component = CreditLimit;
                break;
            case 'gov':
                Component = GovProgramms;
                break;
            case 'energy_all':
                Component = EnergyList;
                break;
            case 'finmon':
                Component = FinMon;
                break;
            case 'cash_proceeds':
                Component = CashProceeds;
                break;
            case 'loans-corporate-clients':
                Component = LoansCorporateClients;
                break;
            case 'quick_cash_business':
                Component = QuickCashBusiness;
                break;
            case 'abusiness':
                Component = ABusiness;
                break;
            default:
                Component = Business;
                break;
        }
    } else {
        Component = Business;
    }

    return (
        <div className='module-business'>
            <Component {...this.props} />
        </div>
    );
}
